<template>
  <div id="RequestForm">
    <v-dialog v-model="agreementDialog" width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t('Заголовок формы согласия')}}</span>
        </v-card-title>
        <v-card-text
          style="padding-left:30px;padding-right:30px;"
          v-html="$t('Текст формы согласия')"
        ></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="margin:7px;"
            color="primary"
            flat
            text
            @click="agreementDialog = false"
          >{{$t('Закрыть')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-progress-circular
      id="progressRequest"
      :size="70"
      :width="7"
      v-if="isLoading"
      indeterminate
      color="primary"
    ></v-progress-circular>
    <h2 v-if="isLoading">{{isLoadingMessage}}</h2>
    <v-card class="card-container elevation-12" v-else>
      <slot name="header">
        <v-card-title primary-title>
          <h1 style="color:#1976D2;">{{title}}</h1>
        </v-card-title>
      </slot>

      <v-container grid-list-md class="main-container">
        <v-layout row wrap>
          <v-flex xs6>
            <div v-for="(vgSchema,i) of vfgSchema" v-bind:key="vgSchema.schemaId">
              <template v-if="i%2==0&&!vgSchema.hide">
                <v-card-title>
                  <p style="font-size:20px;">{{vgSchema.name}}</p>
                </v-card-title>
                <div class="vfg-container">
                  <vue-form-generator
                    v-bind:schema="vgSchema.schema"
                    v-bind:model="vfgModel"
                    v-bind:options="vfgFormOptions"
                    :ref="vgSchema.code"
                  ></vue-form-generator>
                </div>
              </template>
            </div>
          </v-flex>
          <v-flex xs6>
            <div v-for="(vgSchema,i) of vfgSchema" v-bind:key="vgSchema.schemaId">
              <template v-if="i%2!=0&&!vgSchema.hide">
                <v-card-title>
                  <p style="font-size:20px;">{{vgSchema.name}}</p>
                </v-card-title>
                <div class="vfg-container">
                  <vue-form-generator
                    v-bind:schema="vgSchema.schema"
                    v-bind:model="vfgModel"
                    v-bind:options="vfgFormOptions"
                    :ref="vgSchema.code"
                  ></vue-form-generator>
                </div>
              </template>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <div v-if="showInfoMessage" class="show-info">
        <v-card-text class="red--text">
          {{$t('Примечание:')}}
          <b>*</b>
          - {{$t('обязательное поле')}}
        </v-card-text>
        <template v-if="showAgreeCheckBox">
          <v-checkbox v-model="isAgree" class="mb-10" >
            <template v-slot:label>
              <p style="line-height:20px;font-size:16px;margin-bottom:0px">{{$t('Согласен на обработку персональных данных')}} <a id="agreement-link"  @click="agreementDialog=true">{{$t('Форма согласия')}}</a></p>
             
            </template>
          </v-checkbox>

          <p>{{$t('Обратите внимание! Заявку может отправить только владелец лицевого счета.')}}</p>
          <p>{{$t('Ответственность за достоверность предоставленных данных несет заявитель')}}</p>
        </template>
      </div>

      <v-card-text v-if="errorMessage!==''" class="red--text">
        <b>{{errorMessage}}</b>
      </v-card-text>

      <v-card-actions>
        <v-btn
          v-for="(action,index) of actions"
          v-bind:key="index"
          v-bind:disabled="action.disabled||((action.Type==='submit')&&showAgreeCheckBox&&!isAgree)"
          flat
          large
          v-bind:color="action.color"
          @click="btnSubmit(action.code,action.value,action.Type)"
        >{{action.title}}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import 'vue-form-generator/dist/vfg.css';

export default {
    name: 'RequestForm',
    mixins: [],
    props: {
        title: {
            type: String
        },
        errorMessage: {
            type: String
        },
        showInfoMessage: {
            type: Boolean
        },
        showAgreeCheckBox: {
            type: Boolean
        },
        isLoading: {
            type: Boolean
        },
        isLoadingMessage: {
            type: String
        },
        vfgSchema: {},
        vfgModel: {
            type: Object
        },
        // vfgFormOptions: {
        //     type: Object
        // },
        actions: {
            type: Array
        }
    },
    data: () => ({
        isAgree: false,
        agreementDialog: false,
        vfgFormOptions: {
            validateAfterChanged: true,
            validateDebounceTime: 200
        }
        // vfgSchema: [{"code":"mainData","visible":"true","schemaId":"751029ef-e1ed-46c4-86a3-7a4d4ce654bb","name":"Основные данные","schema":{"fields":[{"type":"label","model":"mainData.requestProcessId","visible":false,"label___Kk":"ID процесса","label":"ID процесса"},{"styleClasses":["flex","xs3"],"type":"label","model":"mainData.author","label___Kk":"Автор","label":"Автор"},{"styleClasses":["flex","xs3"],"type":"label","model":"mainData.createDateTime","label___Kk":"Дата создания","label":"Дата создания"},{"styleClasses":["flex","xs3"],"type":"label","model":"mainData.signedDateTime","label___Kk":"Дата подписания","label":"Дата подписания"},{"styleClasses":["flex","xs3"],"type":"label","model":"mainData.status","label___Kk":"Статус","label":"Статус"}]}},{"code":"contactsData","visible":"true","schemaId":"626e023c-dd93-4e20-aced-1b458890bfd9","name":"Контактные данные","schema":{"fields":[{"type":"input","model":"contactsData.email","readonly":true,"inputType":"email","label___Kk":"E-Mail","label":"E-Mail","placeholder___Kk":"Укажите E-mail (каз)","placeholder":"Укажите E-mail"},{"type":"cleave","model":"contactsData.mobilePhoneNumber","required":true,"validator":["required","phoneNumberValidator"],"label___Kk":"Номер мобильного телефона","label":"Номер мобильного телефона","cleaveOptions":{"phone":true,"phoneRegionCode":"kz","creditCard":false,"date":false,"datePattern":["d","m","Y"],"numeral":false,"numeralThousandsGroupStyle":"thousand","numeralDecimalScale":2,"numeralDecimalMark":".","blocks":[],"delimiter":" ","prefix":null,"numericOnly":false,"uppercase":false,"lowercase":false,"maxLength":0,"initValue":""}},{"type":"cleave","model":"contactsData.homePhoneNumber","readonly":true,"label___Kk":"Номер домашнего телефона","label":"Номер домашнего телефона","cleaveOptions":{"phone":true,"phoneRegionCode":"kz","creditCard":false,"date":false,"datePattern":["d","m","Y"],"numeral":false,"numeralThousandsGroupStyle":"thousand","numeralDecimalScale":2,"numeralDecimalMark":".","blocks":[],"delimiter":" ","prefix":null,"numericOnly":false,"uppercase":false,"lowercase":false,"maxLength":0,"initValue":""}}]}},{"code":"accountsData","visible":"true","schemaId":"0e423bb5-bfd9-4221-9a0a-47e58c5a8137","name":"Лицевой счет","schema":{"fields":[{"code":"accountNumber","type":"label","model":"accountsData.account_number","label___Kk":"Дербес шоты","label":"Лицевой счет","values":[]},{"type":"label","model":"accountsData.roes","label___Kk":"РОЭС","label":"РОЭС"},{"type":"label","model":"accountsData.res","label___Kk":"РЭС","label":"РЭС"}]}},{"code":"requestData","visible":"true","schemaId":"26b97afc-6ce2-42e7-91c5-50b1c564fbed","name":"Текст заявки","schema":{"fields":[{"max":"4000","rows":2,"type":"textArea","model":"requestData.text","readonly":true,"label___Kk":"Текст заявки","label":"Текст заявки"},{"max":"4000","rows":2,"type":"textArea","model":"requestData.answer","readonly":false,"label___Kk":"Комментарий к заявке","label":"Комментарий к заявке"},{"code":"returnReasonValues","type":"select","model":"requestData.returnReason","values":[{"id":"Несоответствие документов","name___Kk":"Несоответствие документов","name":"Несоответствие документов"},{"id":"Отсутствие документов","name___Kk":"Отсутствие документов","name":"Отсутствие документов"},{"id":"Несоответствие входной информации","name___Kk":"Несоответствие входной информации","name":"Несоответствие входной информации"}],"readonly":false,"label___Kk":"Причина возврата","label":"Причина возврата","selectOptions":{"noneSelectedText___Kk":"Укажите причину возврата","noneSelectedText":"Укажите причину возврата"}},{"max":"4000","rows":2,"type":"textArea","model":"requestData.comment","readonly":false,"label___Kk":"Комментарий","label":"Комментарий"}]}},{"code":"requestFiles","visible":"true","schemaId":"9f6d4f71-c4a8-48ef-a533-4f62a766a194","name":"Копии документов","schema":{"fields":[{"type":"filepicker","multiple":true,"model":"requestFiles.IdentityCard","label___Kk":"Жеке куәлік","label":"Удостоверение личности","placeholder___Kk":"Приложите копию удостоверения личности","placeholder":"Приложите копию удостоверения личности"}]}}]
    }),
    computed: {},
    methods: {
        async btnSubmit(code, value, type) {
            try {
                let correct = true;
                if (type && type === 'submit') {
                    for (let vg of this.vfgSchema) {
                        if (!vg.hide && this.$refs[vg.code] && !this.$refs[vg.code][0].validate()) {
                            correct = false;
                        }
                    }
                }

                if (correct) {
                    if (value) {
                        this.$emit(code, value);
                    } else {
                        this.$emit(code);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        }
    },
    mounted() {
        // this.single = false; //свойство FileMixin для загрузки нескольких файлов
    }
};
</script>

<style>
#RequestForm {
    padding: 10px;
}
.vfg-container {
    padding-left: 40px;
    padding-right: 40px;
}
.card-container {
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
}

.col > div {
    margin-bottom: 20px;
}

.accent--text {
    color: #1664e6 !important;
}
.theme--light.v-label {
    color: hsla(0, 0%, 0%, 1);
}
.show-info {
    padding-left: 10px;
}
fieldset {
    border: none !important;
}
fieldset div.error {
    background-color: transparent !important;
}

.field-checkbox{
  display: flex;
  gap: 10px;
  cursor: pointer;
}

.field-checkbox label{
  cursor: pointer;
}

.main-data .field-wrap {
    padding-left: 5px;
    font-size: 15px;
}
.main-data fieldset {
    width: 100%;
}
.main-container {
    padding-top: 0px !important;
}
#progressRequest {
    position: absolute;
    top: 50%;
    left: 50%;
}
#agreement-link {
    line-height: initial;
}

.red-text {
    color: red;
}
.small-text {
    font-size: 10px;
}
.form {
    padding-left: 76px;
}
</style>
